/**
 * País da página = segunda metade de meta_pages.language ("Italiano - Itália").
 * Cópia de COUNTRY_NAME_TO_ISO (ms-meta-api services/meta/country_map.py), a
 * mesma regra que o backend usa para o filtro `pais` — manter as duas iguais.
 */
const NOME_PARA_ISO: Record<string, string> = {
    "Afeganistão": 'AF', "Albânia": 'AL', "Alemanha": 'DE', "Argentina": 'AR',
    "Argélia": 'DZ', "Armênia": 'AM', "Arábia Saudita": 'SA', "Austrália": 'AU',
    "Azerbaijão": 'AZ', "Bangladesh": 'BD', "Barein": 'BH', "Belize": 'BZ',
    "Bielorrússia": 'BY', "Bolívia": 'BO', "Brasil": 'BR', "Bulgária": 'BG',
    "Bélgica": 'BE', "Bósnia e Herzegovina": 'BA', "Camboja": 'KH', "Canadá": 'CA',
    "Catar": 'QA', "Cazaquistão": 'KZ', "Chile": 'CL', "China": 'CN',
    "Chipre": 'CY', "Colômbia": 'CO', "Coreia do Sul": 'KR', "Costa Rica": 'CR',
    "Croácia": 'HR', "Dinamarca": 'DK', "Egito": 'EG', "El Salvador": 'SV',
    "Emirados Árabes Unidos": 'AE', "Equador": 'EC', "Eslováquia": 'SK', "Eslovênia": 'SI',
    "Espanha": 'ES', "Estados Unidos": 'US', "Estônia": 'EE', "Etiópia": 'ET',
    "Filipinas": 'PH', "Finlândia": 'FI', "França": 'FR', "Geórgia": 'GE',
    "Gibraltar": 'GI', "Grécia": 'GR', "Guatemala": 'GT', "Haiti": 'HT',
    "Honduras": 'HN', "Hong Kong": 'HK', "Hungria": 'HU', "Indonésia": 'ID',
    "Irlanda": 'IE', "Irã": 'IR', "Islândia": 'IS', "Israel": 'IL',
    "Itália": 'IT', "Japão": 'JP', "Kuwait": 'KW', "Laos": 'LA',
    "Letônia": 'LV', "Lituânia": 'LT', "Luxemburgo": 'LU', "Líbano": 'LB',
    "Macedônia do Norte": 'MK', "Malta": 'MT', "Malásia": 'MY', "Marrocos": 'MA',
    "Mianmar [Birmânia]": 'MM', "Mongólia": 'MN', "México": 'MX', "Nepal": 'NP',
    "Nicarágua": 'NI', "Nigéria": 'NG', "Noruega": 'NO', "Nova Zelândia": 'NZ',
    "Omã": 'OM', "Panamá": 'PA', "Paquistão": 'PK', "Paraguai": 'PY',
    "Países Baixos": 'NL', "Peru": 'PE', "Polônia": 'PL', "Porto Rico": 'PR',
    "Portugal": 'PT', "Quirguistão": 'KG', "Quênia": 'KE', "Reino Unido": 'GB',
    "República Dominicana": 'DO', "Romênia": 'RO', "Rússia": 'RU', "Singapura": 'SG',
    "Sri Lanka": 'LK', "Suécia": 'SE', "Suíça": 'CH', "Sérvia": 'RS',
    "Tadjiquistão": 'TJ', "Tailândia": 'TH', "Taiwan": 'TW', "Tanzânia": 'TZ',
    "Tchéquia": 'CZ', "Tunísia": 'TN', "Turcomenistão": 'TM', "Turquia": 'TR',
    "Ucrânia": 'UA', "Uruguai": 'UY', "Uzbequistão": 'UZ', "Venezuela": 'VE',
    "Vietnã": 'VN', "África do Sul": 'ZA', "Áustria": 'AT', "Índia": 'IN',
};

export const paisDaPagina = (language: string | null | undefined): { codigo: string; nome: string } | null => {
    if (!language || !language.includes(' - ')) return null;
    const nome = language.split(' - ').slice(1).join(' - ').trim();
    const codigo = NOME_PARA_ISO[nome];
    return codigo ? { codigo, nome } : null;
};
